import { render, staticRenderFns } from "./MapPin.vue?vue&type=template&id=313f2a70&"
import script from "./MapPin.vue?vue&type=script&lang=ts&"
export * from "./MapPin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports